import { useRef, useState } from "react";
import { Mic, Square, Loader2 } from "lucide-react";
import { uploadVoice, apiError } from "@/lib/portalApi";
import { toast } from "sonner";

// A single mic button that records a voice note and returns its storage path.
export default function VoiceRecorder({ onRecorded, testid }) {
  const [recording, setRecording] = useState(false);
  const [uploading, setUploading] = useState(false);
  const recRef = useRef(null);
  const chunksRef = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const rec = new MediaRecorder(stream);
      chunksRef.current = [];
      rec.ondataavailable = (e) => e.data.size && chunksRef.current.push(e.data);
      rec.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunksRef.current, { type: rec.mimeType || "audio/webm" });
        setUploading(true);
        try { const up = await uploadVoice(blob); onRecorded(up.path); }
        catch (e) { toast.error(apiError(e)); }
        finally { setUploading(false); }
      };
      recRef.current = rec; rec.start(); setRecording(true);
    } catch { toast.error("Microphone access is needed to record."); }
  };
  const stop = () => { recRef.current?.stop(); setRecording(false); };

  if (uploading) return <span className="inline-flex items-center gap-1.5 text-xs text-[#8a7a6a]"><Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} />Saving…</span>;
  return recording ? (
    <button type="button" data-testid={testid ? `${testid}-stop` : undefined} onClick={stop} className="rounded-full bg-[#b45c5c] text-white p-2.5 animate-pulse">
      <Square className="w-4 h-4" strokeWidth={2} fill="currentColor" />
    </button>
  ) : (
    <button type="button" data-testid={testid ? `${testid}-start` : undefined} onClick={start} title="Record a voice note" className="rounded-full bg-[#EAE3D9] hover:bg-[#e0d8c9] text-[#A9724E] p-2.5 transition-colors">
      <Mic className="w-4 h-4" strokeWidth={1.5} />
    </button>
  );
}
